<template>
  <ul class="illustrateCom">
    <li v-for="(v, i) in list" :key="i">
      <h5>
        {{ v.name }}
        <el-button
          v-if="$route.path == '/systemDescription'"
          type="primary"
          size="mini"
          style="margin-left: 20px"
          >下载</el-button
        >
      </h5>
      <template v-if="$route.path == '/systemDescription'">
        <p>{{ v.file }}</p></template
      >
      <template v-else>
        <p>提交时间: {{ v.time }}</p>
        <p>描述: {{ v.describe }}</p>
        <p>附件: {{ v.file }}</p>
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.illustrateCom {
  width: 80%;
  margin: 0 auto;
  padding: 20px 0 16px;
  li {
    width: 100%;
    margin-bottom: 25px;
    padding-bottom: 25px;
    border-bottom: 1px dotted #e5e5e5;
    h5 {
      font-size: 18px;
      margin-bottom: 20px;
      @include setFlexStart;
    }
    p:not(:last-child) {
      margin-bottom: 20px;
    }
  }
}
</style>
